<template>
    <bottom-sheet v-model="shows" v-bind="{ title }">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-sheet width="100%" max-width="400px" class="mx-auto">
            <v-row class="ma-n2">
                <v-col class="pa-2" cols="12">
                    <v-text-field v-model="form.subject" v-bind="attrs_input" label="계약명" />
                </v-col>
                <v-col class="pa-2" cols="12">
                    <autocomplete-employment-form v-model="form._form" v-bind="attrs_input" label="계약서 양식">
                        <template #append-outer>
                            <employment-form-view :value="{ _id: form._form }">
                                <template #activator="{ attrs, on }">
                                    <v-btn small text icon v-bind="attrs" v-on="on" :disabled="!form._form">
                                        <v-icon>mdi-file-document-outline</v-icon>
                                    </v-btn>
                                </template>
                            </employment-form-view>
                        </template>
                    </autocomplete-employment-form>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <autocomplete-user v-model="form._user" v-bind="attrs_input" label="계약 대상자" />
                </v-col>
            </v-row>
        </v-sheet>

        <template #foot>
            <v-btn v-bind="{ loading }" color="error" outlined @click="init"> <span>초기화</span> </v-btn>
            <v-btn v-bind="{ loading }" color="primary" @click="save"> <span>저장하기</span> </v-btn>
        </template>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input, initEmploymentContract } from "@/assets/variables";

import AutocompleteEmploymentForm from "@/components/dumb/autocomplete-employment-form.vue";
import AutocompleteUser from "@/components/dumb/autocomplete-user.vue";
import BottomSheet from "@/components/console/dumb/bottom-sheet.vue";
import EmploymentFormView from "@/components/console/employment/form/employment-form-view.vue";

export default {
    components: {
        AutocompleteEmploymentForm,
        AutocompleteUser,
        BottomSheet,
        EmploymentFormView,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
    },
    setup: () => ({
        attrs_input,
    }),
    data: () => ({
        /** @type {import('vue').Ref<import('@/assets/variables').EmploymentContract>} */
        form: initEmploymentContract(),

        shows: false,
        loading: false,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "계약";
            title += this.isCreate ? " 생성" : " 수정";
            return title;
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                if (this.isCreate) {
                    this.form = initEmploymentContract(this.value);
                } else {
                    let { contract } = await api.console.employment.contracts.get({ _id: this.value._id });
                    this.form = initEmploymentContract(contract);
                }
            } finally {
                this.loading = false;
            }
        },
        async save() {
            if (!this.validates()) return;
            if (this.loading) return;
            else this.loading = true;

            try {
                let { ...form } = this.form;

                ////////////////////////////////////////////////////////////////
                // 데이터 저장
                ////////////////////////////////////////////////////////////////
                let { post, put } = api.console.employment.contracts;
                form = (await (!form._id ? post : put)(form))?.contract;

                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", form);
            } finally {
                this.loading = false;
                this.shows = false;
            }
        },
        validates() {
            try {
                if (!this.form.subject) throw new Error("계약명을 입력해주세요");
                if (!this.form._form) throw new Error("계약서를 선택해주세요");
                if (!this.form._user) throw new Error("사용자를 선택해주세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        emit() {
            this.form = initEmploymentContract(this.form);
        },
    },
    watch: {
        value() {
            if (this.shows) this.init();
        },
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped></style>
